import { alphabeticalSort } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'
import { RenderCustomExpandableSubsection } from 'components/CIMSTable/CIMSTableContext/hooks/useExpandableSection/components/ExpandableSection/types'
import { PayItemConnection } from '../../ConnectionsContext'

export function googleSheetFields(
  googleSheet?: PayItemConnection['googleSheet']
): RenderCustomExpandableSubsection {
  const {
    documentId,
    sheetId,
    payItemColumnKey,
    headers = [],
  } = googleSheet ?? {}
  const help = HelpMessage.PayItems.Manage.Connections.GoogleSheet
  return {
    type: 'fields',
    title: 'Google Sheet',
    hidden: !googleSheet,
    fields: [
      {
        type: 'default',
        label: 'Document ID',
        children: documentId,
        help: help.DocumentId,
      },
      {
        type: 'default',
        label: 'Sheet ID',
        children: sheetId,
        help: help.SheetId,
      },
      {
        type: 'default',
        label: 'Pay Item Column Key',
        children: payItemColumnKey,
        help: help.PayItemColumnKey,
      },
      {
        type: 'tags',
        label: 'Headers',
        noSort: true,
        help: help.Headers,
        tags: headers
          .filter(({ visible }) => visible)
          .sort(alphabeticalSort('order'))
          .map(({ formattedValue, id }) => ({
            text: formattedValue,
            tooltip: id,
          })),
      },
    ],
  }
}
